export default "__VITE_ASSET__kpbF$4N8__"